import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { iinValidator } from "../../validators/iin.validator";
import { NotificationService } from "../../services/notification.service";
import { InformationDataServiceService } from "./services/information-data-service.service";
import { EditInformationModelsDto, InformationModelsDto } from "./models/information.models";
import { symbolValidator } from "../../validators/symbol.validator";
import { notSymbolValidator } from "../../validators/not-symbol.validator";

@Component({
	selector: "app-information",
	templateUrl: "./information.component.html",
	styleUrls: ["./information.component.scss"],
})
export class InformationComponent implements OnInit {
	form!: FormGroup;

	isEdit = false;

	bin = "";
	agentName = "";
	activityType = "";
	email = "";
	phoneNumber = "";
	directorName = "";
	accountantName = "";

	info: InformationModelsDto | undefined;

	constructor(
		private notificationService: NotificationService,
		private informationDataServiceService: InformationDataServiceService
	) {}

	ngOnInit() {
		this.loadInfo();
		this.initForm();
	}

	loadInfo() {
		this.informationDataServiceService.loadInfo().subscribe({
			next: (res) => {
				this.info = res;
				this.form.patchValue({ nameFormControl: res.agent_name });
				this.form.patchValue({ binFormControl: res.BIN });
				this.form.patchValue({ emailFormControl: res.email });
				this.form.patchValue({ phoneFormControl: res.phone_number });
				this.form.patchValue({ directorNameFormControl: res.director_name });
				this.form.patchValue({ bookerNameFormControl: res.accountant_name });
				this.form.patchValue({ metierFormControl: res.activity_type });
				this.form.patchValue({ agentIdFormControl: res.agent_id });
			},
		});
	}

	editData() {
		this.isEdit = true;
	}

	initForm(): void {
		this.form = new FormGroup({
			nameFormControl: new FormControl("", [Validators.required, notSymbolValidator()]),
			binFormControl: new FormControl("", [Validators.required, Validators.minLength(12), iinValidator()]),
			emailFormControl: new FormControl("", [Validators.required, Validators.email]),
			phoneFormControl: new FormControl("", [Validators.required, Validators.minLength(10)]),
			directorNameFormControl: new FormControl("", [Validators.required]),
			metierFormControl: new FormControl("", [Validators.required]),
			bookerNameFormControl: new FormControl(""),
			agentIdFormControl: new FormControl({ value: "", disabled: true }),
		});
	}

	get nameRequiredError() {
		return this.form.get("nameFormControl")?.hasError("required");
	}

	get nameFormatError() {
		return this.form.get("nameFormControl")?.hasError("symbolNotValid");
	}

	get binRequiredError() {
		return this.form.get("binFormControl")?.hasError("required");
	}

	get binFormatError() {
		return this.form.get("binFormControl")?.hasError("minlength");
	}

	get emailRequiredError() {
		return this.form.get("emailFormControl")?.hasError("required");
	}

	get emailFormatError() {
		return this.form.get("emailFormControl")?.hasError("email");
	}

	get phoneRequiredError() {
		return this.form.get("phoneFormControl")?.hasError("required");
	}

	get phoneFormatError() {
		return this.form.get("phoneFormControl")?.hasError("minlength");
	}

	get directorNameRequiredError() {
		return this.form.get("directorNameFormControl")?.hasError("required");
	}

	get metierRequiredError() {
		return this.form.get("metierFormControl")?.hasError("required");
	}

	sendForm() {
		let phone = this.form.get("phoneFormControl")?.value;
		if (!phone.includes("+")) {
			phone = `+${phone}`;
		}
		const data: EditInformationModelsDto = {
			agent_name: this.form.get("nameFormControl")?.value,
			BIN: this.form.get("binFormControl")?.value,
			activity_type: this.form.get("metierFormControl")?.value,
			email: this.form.get("emailFormControl")?.value,
			phone_number: phone,
			director_name: this.form.get("directorNameFormControl")?.value,
			accountant_name: this.form.get("bookerNameFormControl")?.value,
			agent_id: this.form.get("agentIdFormControl")?.getRawValue(),
		};

		this.informationDataServiceService.saveInfo(data).subscribe({
			next: () => {
				this.loadInfo();

				this.notificationService.setConfiguration(
					"icon-2",
					"warning",
					"INFORMATION_PAGE.NOTIFICATION.TITLE",
					"INFORMATION_PAGE.NOTIFICATION.DESCRIPTION"
				);
				this.notificationService.showNotification();
				this.isEdit = false;
			},
		});
	}
}
